export enum EStatus {
  error = 'error',
  success = 'success',
  warning = 'warning',
  info = 'info',
}

export type TStatus = keyof typeof EStatus;
